import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AirSavedCardModel } from "entities/AirSavedCard";
import { SeaSavedCardModel } from "entities/SeaSavedCard";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type TagsState = SeaSavedCardModel | AirSavedCardModel;
export type CurrentTag = string | null;
type Tags = {
  cardsByTags: TagsState[];
  currentTag: CurrentTag;
};

const initialTagsState: Tags = {
  cardsByTags: [],
  currentTag: null,
};

const tagsSlice = createSlice({
  name: "tags",
  initialState: initialTagsState,
  reducers: {
    setCurrentTag: (state, action: PayloadAction<CurrentTag>) => {
      state.currentTag = action.payload;
    },
    appendCardsByTagAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: TagsState[]; unique?: boolean }>
    ) => {
      if (unique) {
        const referencesSet = new Set<string>();
        state.cardsByTags.forEach((item) => {
          if (item.reference) {
            referencesSet.add(item.reference);
          }
        });

        data.forEach((item) => {
          if (item.reference && !referencesSet.has(item.reference)) {
            state.cardsByTags.push(item);
          }
        });
        return state;
      }
      state.cardsByTags = state.cardsByTags.concat(data);
    },
    removeCardByTagAction: (state, action: PayloadAction<TagsState>) => {
      state.cardsByTags = state.cardsByTags.filter((card) => card.reference !== action.payload.reference);
      return state;
    },
    clearCardsByTagAction: (state) => {
      state.cardsByTags = [];
      return state;
    },
    updateCardByTagAction: (state, action: PayloadAction<TagsState>) => {
      const targetCard = state.cardsByTags.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state.cardsByTags[targetCard] = action.payload;
      }
    },
    setCardsByTagAction: (state, action: PayloadAction<TagsState[]>) => {
      state.cardsByTags = action.payload;
    },
  },
});

const tagsBaseSelector = createBaseSelector(tagsSlice);

registerSlice([tagsSlice]);

export const tagsStore = {
  actions: tagsSlice.actions,
  selectors: {
    currentTag: createSelector(tagsBaseSelector, (s) => s.currentTag),
    cardsByTags: createSelector(tagsBaseSelector, (s) => s.cardsByTags),
  },
};
